import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CartService } from 'src/app/shared-core/services/cart.service';
import { AddToCartWithAttributesPayload, Item, ItemMinimalDetails } from 'src/app/shared-core/models/cart-data.model';
import { catchError } from 'rxjs/operators';
import { ToastService } from 'ng-uikit-pro-standard';
import { of } from 'rxjs';

@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent {
    @Input() product: ItemMinimalDetails;
    @Input() showCheckbox: boolean = false;
    @Input() isSelected: boolean = false;
    @Input() showAddToCart: boolean = true;
    @Input() showSmallImages: boolean = false;
    @Input() source: string;
    @Output() onCheckedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() addedToCart = new EventEmitter<Item>();
    public isAddingToCart: boolean = false;
    public hasAlt = true;

    constructor(private _cartService: CartService, private _toaster: ToastService) {}

    public addToCart(webCode: string): void {
        const payload = {
            type: 'ShoppingCart',
            source: 'Items',
            webCode: webCode,
            quantity: 1,
            attributes: {}
        } as AddToCartWithAttributesPayload;

        this.isAddingToCart = true;
        this._cartService
            .addToCartWithAttributes(payload, this.source)
            .pipe(
                catchError(() => {
                    this._toaster.error('An error occured adding to cart. Please try again.', 'Unable to add to cart');
                    return of(null);
                })
            )
            .subscribe((item) => {
                this.isAddingToCart = false;

                if (!item) {
                    this._toaster.error('An error occured adding to cart. Please try again.', 'Unable to add to cart');
                    return;
                }

                this.addedToCart.emit(item);
            });
    }

    onCheckboxChange(event: Event) {
        const selected = (event.currentTarget as HTMLInputElement).checked;
        this.onCheckedChange.emit(selected);
    }

    public setFallbackImage(event: any, type: string) {
        const fallbackLargeUrl = 'https://img.vistek.net/prodimg/large/blank.jpg';
        const fallback200Url = 'https://img.vistek.net/prodimg/200/blank.jpg';

        event.target.src = fallback200Url;
        event.target.srcset = `${fallback200Url} 200w, ${fallbackLargeUrl} 500w`;

        if (type === 'alt') {
            this.hasAlt = false;
        }
    }

    public getImageURL(imgURI: string) {
        if (!imgURI) return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
        return 'https://img.vistek.net' + imgURI[0];
      }
}
